module.exports = __webpack_public_path__ + "static/media/household-cleaning.33d95d45.jpg";